import './blocks'

document.addEventListener(
    "DOMContentLoaded",
    function () {
        const goBackElements = document.querySelectorAll<HTMLElement>('.on-click__history-back, #go-back a');

        const onBackElementClick = function(e) {
            e.preventDefault();
            history.back();
        }

        const setupBackElement = function(goBackElement) {
            goBackElement.addEventListener('click', onBackElementClick);
        }

        goBackElements.forEach(setupBackElement);
    }
);
